var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMpay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.03 25.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.43.7H4.7A.35.35,0,0,0,4.36,1L0,25.67A.23.23,0,0,0,.25,26H7a.37.37,0,0,0,.35-.29L11.67,1A.24.24,0,0,0,11.43.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.06,0,13.61,19.62a9.85,9.85,0,0,0,2.45.3h.22L19.68.67A10,10,0,0,0,17.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.66,17.59a10.07,10.07,0,0,0,2.77,1.65L15.83,0a10.13,10.13,0,0,0-3.18.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.88,19.75a9.9,9.9,0,0,0,2.55-.83L23.23,3a10.08,10.08,0,0,0-2.11-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.77,5.12,22.59,17.48A9.93,9.93,0,0,0,24.77,5.12"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpay);
export default __webpack_public_path__ + "static/media/mpay.48e06eb41083c53d699a635799d899d4.svg";
export { ForwardRef as ReactComponent };